import React, { useState, useEffect } from 'react';
import { Card, Stack, Button } from '@mui/material';
import { MIGRATION_STATUS_COLUMNS } from '../../config/module-configs/subscriber-reports.config';
import ListData from '../table-elements/list-data.component';
import Iconify from '../common/iconify.component';
import { getChannelsMigrationStatus } from '../../services/admin-reports.service';
import useFilteredActions from '../../hooks/filtered-action.hook';
import useAbortableRequest from '../../hooks/abortable-request.hook';

const MigrationStatus = () => {
  const columns = MIGRATION_STATUS_COLUMNS;
  const actions = useFilteredActions('analytics', []);
  const { getSignal, isAbortError } = useAbortableRequest();

  const [options, setOptions] = useState({
    page: 0,
    rowsPerPage: 100,
    totalRows: 0,
    rows: [],
    reloadCounter: 0,
    sortBy: '',
    sortOrder: '',
    error: false,
    loading: true,
  });

  const handlePageChange = (v) => {
    setOptions({
      ...options,
      page: v,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleRowsPerPageChange = (v) => {
    setOptions({
      ...options,
      rowsPerPage: v,
      page: 0,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleSortingChange = (sortBy, sortOrder) => {
    setOptions({
      ...options,
      sortBy,
      sortOrder,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleRefreshData = () => {
    setOptions({
      ...options,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  useEffect(() => {
    const signal = getSignal();
    const params = [];
    params.push(`page=${options.page + 1}`);
    params.push(`perPage=${options.rowsPerPage}`);
    if (options.sortBy && options.sortOrder) {
      params.push(`sortBy=${options.sortBy}`);
      params.push(`sortOrder=${options.sortOrder}`);
    }

    const paramsQuery = params.length > 0 ? `?${params.join('&')}` : '';
    getChannelsMigrationStatus(paramsQuery, signal)
      .then((res) => {
        if (!signal.aborted) {
          setOptions({
            ...options,
            loading: false,
            totalRows: res?.data?.totalRows || 0,
            rows: res?.data?.rows || [],
            error: false,
          });
        }
      })
      .catch((err) => {
        if (isAbortError(err)) return;
        setOptions({
          ...options,
          loading: false,
          page: 0,
          totalRows: 0,
          rows: [],
          error: true,
        });
      });
  }, [options.reloadCounter]);

  return (
    <>
      <Stack direction="row" justifyContent="right" sx={{ px: 0, py: 2 }}>
        <Button
          color="inherit"
          variant="contained"
          startIcon={<Iconify icon="ic:twotone-refresh" />}
          onClick={handleRefreshData}
          disabled={options.loading}
        >
          Refresh
        </Button>
      </Stack>

      <Card>
        <ListData
          columns={columns}
          rows={options.rows}
          page={options.page}
          rowsPerPage={options.rowsPerPage}
          totalRows={options.totalRows}
          loading={options.loading}
          actions={actions}
          error={options.error}
          sortBy={options.sortBy}
          sortOrder={options.sortOrder}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onSortChange={handleSortingChange}
          forReports
        />
      </Card>
    </>
  );
};

export default MigrationStatus;
